import map from 'lodash/map'
import React from 'react'
import { useContext } from './Context'
import { BlogBox } from '@ztechapps/blog.webui'
import { routesDef } from '../../../config/routes'
import { LoadMoreButton } from '@ztechapps/webui.button'
import type { Blog } from '@ztechapps/common.contract'
import { PageTitle } from '../../../components/PageTitle'
export const Layout = () => {
  const { list, pageInfo, loadMoreEntries, loading, sort, filter } = useContext()

  return (
    <div>
      <PageTitle
        title="Latest News & Updates"
        description="Stay updated with the latest news, articles, and updates from PanelPunches."
      />
      <div className="row g-3">
        {map(list, (blog: Blog) => (
          <div key={blog?._id} className="col-md-4">
            <BlogBox
              title={blog.title}
              summary={blog.summary}
              updatedAt={blog.updatedAt}
              status={blog.status}
              tags={blog.tags}
              cover={blog.cover}
              linkToPath={routesDef.UseAndCareItemPage.altPath(blog._id)}
            />
          </div>
        ))}
      </div>

      <LoadMoreButton
        {...{
          dataArray: list,
          pageInfo,
          loadMoreEntries,
          loading,
          sort,
          filter,
        }}
      />
    </div>
  )
}
